import type { ReactNode } from 'react'
import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import { useShowBottomNav } from '@hooks/useShowBottomNav'
import { useShowMiniSessionBar } from '@hooks/useShowMiniSessionBar'
import { BOTTOM_NAV_HEIGHT, MINI_SESSION_BAR_HEIGHT } from './layoutConstants'
import { useShellOverlayMetrics } from './shellOverlayMetrics'

type PageContentProps = {
  children: ReactNode
  sx?: SxProps<Theme>
}

/** Wraps routed content; adds bottom inset for nav, mini bar, overlay banners, and iOS keyboard. */
export function PageContent({ children, sx }: PageContentProps) {
  const showBottomNav = useShowBottomNav()
  const showMiniBar = useShowMiniSessionBar()
  const { bannerHeightPx, keyboardInsetPx } = useShellOverlayMetrics()
  const bottomInsetPx =
    (showBottomNav ? BOTTOM_NAV_HEIGHT : 0) +
    (showMiniBar ? MINI_SESSION_BAR_HEIGHT : 0) +
    bannerHeightPx +
    keyboardInsetPx

  return (
    <Box
      sx={[
        bottomInsetPx > 0 && {
          paddingBottom: `calc(${bottomInsetPx}px + env(safe-area-inset-bottom, 0px))`,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  )
}

export default PageContent
